import { useOrganizationSettingsQuery } from '@cast/infrastructure-abilities';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useIsOrganizationReadOnly = (): boolean => {
  const { currentOrganization } = useOrganizations();
  const { data: orgSettings } = useOrganizationSettingsQuery({
    organizationId: currentOrganization?.id,
  });
  return !!orgSettings?.readOnly;
};
